import { render } from "./MyStack.vue?vue&type=template&id=73eb60e2&scoped=true"
import script from "./MyStack.vue?vue&type=script&lang=js"
export * from "./MyStack.vue?vue&type=script&lang=js"

import "./MyStack.vue?vue&type=style&index=0&id=73eb60e2&scoped=true&lang=scss"

import exportComponent from "/srv/http/cv.mzubiaga.net/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73eb60e2"]])

export default __exports__